import type { MilestoneStatus } from "@/views/PlanOfRecord/planOfRecordData";

const STATUS_META: Record<
  MilestoneStatus,
  { label: string; className: string }
> = {
  "on-track": { label: "On track", className: "bg-[#DCFCE7] text-[#15803D]" },
  "at-risk": { label: "At risk", className: "bg-[#FEF3C7] text-[#B26500]" },
  late: { label: "Late", className: "bg-[#FEE2E2] text-[#B91C1C]" },
  complete: { label: "Complete", className: "bg-[#D2EFF9] text-[#06709B]" },
};

export function StatusBadge({ status }: { status: MilestoneStatus }) {
  const meta = STATUS_META[status];

  return (
    <span
      className={`inline-flex h-5 items-center rounded-[4px] px-1.5 text-[12px] font-semibold ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
